import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const DownloadIcon = () => <FontAwesomeIcon icon={["fas", "file-download"]}/>

export default DownloadIcon;